import React, { useState, useMemo, useEffect, useContext } from 'react';
import { RestHelper } from '../../helper/restHelper';
import { UserContext } from '../../app';
import AdminFinancialsPaymentModal from './admin-financials-payment-modal';
import AdminFinancialsVoidModal from './admin-financials-void-modal';
import AdminFinancialsEditFeeModal from './admin-financials-edit-fee-modal';

// ---------------------------------------------------------------------------
// Mock data — replace with RestHelper call to GET /api/financials
// ---------------------------------------------------------------------------
const MOCK_ORDERS = [
  {
    order_id: 'ORD-001', file_number: 'F-2026-0441', title_company: 'First National Title',
    firm_id: 'FIRM-001', appointment_name: 'John Smith', notary_name: 'Maria Garcia',
    notary_id: 'NTY-0001', pinpoint_invoice_number: 'INV-1041', created_at: '2026-04-02T10:00:00Z',
    ar: { status: 'pending', amount: 175.00, original_amount: 175.00, qb_invoice_id: null },
    ap: { status: 'pending', amount: 115.00, original_amount: 115.00, qb_expense_id: null },
  },
  {
    order_id: 'ORD-002', file_number: 'F-2026-0442', title_company: 'First National Title',
    firm_id: 'FIRM-001', appointment_name: 'Linda Torres', notary_name: 'Maria Garcia',
    notary_id: 'NTY-0001', pinpoint_invoice_number: 'INV-1042', created_at: '2026-04-05T14:00:00Z',
    ar: { status: 'pending', amount: 150.00, original_amount: 150.00, qb_invoice_id: null },
    ap: { status: 'pending', amount: 100.00, original_amount: 100.00, qb_expense_id: null },
  },
  {
    order_id: 'ORD-003', file_number: 'F-2026-0443', title_company: 'Lakeside Escrow',
    firm_id: 'FIRM-002', appointment_name: 'Robert Chen', notary_name: 'David Kim',
    notary_id: 'NTY-0002', pinpoint_invoice_number: 'INV-1043', created_at: '2026-04-07T09:00:00Z',
    ar: { status: 'invoiced', amount: 200.00, original_amount: 200.00, qb_invoice_id: 'QB-INV-8801' },
    ap: { status: 'pending', amount: 130.00, original_amount: 130.00, qb_expense_id: null },
  },
  {
    order_id: 'ORD-004', file_number: 'F-2026-0444', title_company: 'Lakeside Escrow',
    firm_id: 'FIRM-002', appointment_name: 'Sarah Johnson', notary_name: 'David Kim',
    notary_id: 'NTY-0002', pinpoint_invoice_number: 'INV-1044', created_at: '2026-04-09T11:00:00Z',
    ar: { status: 'invoiced', amount: 175.00, original_amount: 175.00, qb_invoice_id: 'QB-INV-8802' },
    ap: { status: 'pending', amount: 110.00, original_amount: 110.00, qb_expense_id: null },
  },
  {
    order_id: 'ORD-005', file_number: 'F-2026-0445', title_company: 'Summit Title Group',
    firm_id: 'FIRM-003', appointment_name: 'Michael Brown', notary_name: 'Lisa Wong',
    notary_id: 'NTY-0003', pinpoint_invoice_number: 'INV-1045', created_at: '2026-04-10T08:00:00Z',
    ar: { status: 'paid', amount: 225.00, original_amount: 225.00, qb_invoice_id: 'QB-INV-8803', qb_payment_id: 'QB-PMT-501', payment_date: '2026-04-15', check_number: '4421' },
    ap: { status: 'paid', amount: 150.00, original_amount: 150.00, qb_expense_id: 'QB-EXP-201', payment_date: '2026-04-14', check_number: '1102' },
  },
  {
    order_id: 'ORD-006', file_number: 'F-2026-0446', title_company: 'Pacific Coast Escrow',
    firm_id: 'FIRM-004', appointment_name: 'Angela Davis', notary_name: 'Tom Nguyen',
    notary_id: 'NTY-0004', pinpoint_invoice_number: 'INV-1046', created_at: '2026-04-11T13:00:00Z',
    ar: { status: 'invoiced', amount: 195.00, original_amount: 195.00, qb_invoice_id: 'QB-INV-8804' },
    ap: { status: 'paid', amount: 125.00, original_amount: 125.00, qb_expense_id: 'QB-EXP-202', payment_date: '2026-04-16', check_number: '1103' },
  },
  {
    order_id: 'ORD-007', file_number: 'F-2026-0447', title_company: 'Harbor Title Services',
    firm_id: 'FIRM-005', appointment_name: 'James Wilson', notary_name: 'Maria Garcia',
    notary_id: 'NTY-0001', pinpoint_invoice_number: 'INV-1047', created_at: '2026-04-12T10:00:00Z',
    ar: { status: 'pending', amount: 160.00, original_amount: 160.00, qb_invoice_id: null },
    ap: { status: 'paid', amount: 105.00, original_amount: 105.00, qb_expense_id: 'QB-EXP-203', payment_date: '2026-04-16', check_number: '1104' },
  },
  {
    order_id: 'ORD-008', file_number: 'F-2026-0448', title_company: 'First National Title',
    firm_id: 'FIRM-001', appointment_name: 'Patricia Moore', notary_name: 'David Kim',
    notary_id: 'NTY-0002', pinpoint_invoice_number: 'INV-1048', created_at: '2026-04-14T15:00:00Z',
    ar: { status: 'voided', amount: 150.00, original_amount: 150.00, qb_invoice_id: null, voided_at: '2026-04-15T10:00:00Z', void_reason: 'Order cancelled by client' },
    ap: { status: 'voided', amount: 100.00, original_amount: 100.00, qb_expense_id: null, voided_at: '2026-04-15T10:00:00Z', void_reason: 'Order cancelled by client' },
  },
  {
    order_id: 'ORD-009', file_number: 'F-2026-0449', title_company: 'Summit Title Group',
    firm_id: 'FIRM-003', appointment_name: 'Charles Taylor', notary_name: 'Lisa Wong',
    notary_id: 'NTY-0003', pinpoint_invoice_number: 'INV-1049', created_at: '2026-04-15T09:00:00Z',
    ar: { status: 'paid', amount: 180.00, original_amount: 180.00, qb_invoice_id: 'QB-INV-8805', qb_payment_id: 'QB-PMT-502', payment_date: '2026-04-17', check_number: '4422' },
    ap: { status: 'pending', amount: 120.00, original_amount: 120.00, qb_expense_id: null },
  },
  {
    order_id: 'ORD-010', file_number: 'F-2026-0450', title_company: 'Pacific Coast Escrow',
    firm_id: 'FIRM-004', appointment_name: 'Nancy White', notary_name: 'Tom Nguyen',
    notary_id: 'NTY-0004', pinpoint_invoice_number: 'INV-1050', created_at: '2026-04-17T11:00:00Z',
    ar: { status: 'pending', amount: 190.00, original_amount: 190.00, qb_invoice_id: null },
    ap: { status: 'pending', amount: 125.00, original_amount: 125.00, qb_expense_id: null },
  },
];

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------
const fmt = (n) => `$${(n || 0).toFixed(2)}`;

const firstOfMonth = () => {
  const d = new Date();
  return new Date(d.getFullYear(), d.getMonth(), 1).toISOString().split('T')[0];
};

const todayStr = () => new Date().toISOString().split('T')[0];

const statusBadge = (status, withStrike = false) => {
  const map = {
    pending:  'bg-amber-100 text-amber-700',
    invoiced: 'bg-blue-100 text-blue-700',
    paid:     'bg-green-100 text-green-700',
    voided:   'bg-red-100 text-red-500',
  };
  const cls = map[status] || 'bg-neutral-100 text-neutral-600';
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${cls} ${withStrike ? 'line-through' : ''}`}>
      {status || '—'}
    </span>
  );
};

// ---------------------------------------------------------------------------
// Summary card
// ---------------------------------------------------------------------------
const SummaryCard = ({ label, value, sub }) => (
  <div className="bg-white rounded-xl shadow-sm border border-neutral-200 p-4 flex flex-col gap-1">
    <span className="text-xs font-medium text-neutral-500 uppercase tracking-wide">{label}</span>
    <span className="text-2xl font-bold text-neutral-800">{value}</span>
    {sub && <span className="text-xs text-neutral-400">{sub}</span>}
  </div>
);

// ---------------------------------------------------------------------------
// Main component
// ---------------------------------------------------------------------------
const AdminFinancials = () => {
  const [orders, setOrders] = useState(MOCK_ORDERS);
  // TODO: replace mock load with:
  // api.get(`/api/financials?date_from=${dateFrom}&date_to=${dateTo}&status_filter=${statusFilter}&search=${searchText}`)

  const api = RestHelper();
  const { userProfile } = useContext(UserContext);
  const [qbConnected] = useState(true);
  const [firms, setFirms] = useState([]);
  const [selectedFirmId, setSelectedFirmId] = useState('');

  useEffect(() => {
    api.postCreate('/get-firm-list', {}, { activeUser: userProfile.profileEmail })
      .then(res => setFirms(res.firms || []))
      .catch(err => console.log(err));
  }, []);
  const [dateFrom, setDateFrom] = useState(firstOfMonth());
  const [dateTo, setDateTo] = useState(todayStr());
  const [statusFilter, setStatusFilter] = useState('all');
  const [searchText, setSearchText] = useState('');
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [activeModal, setActiveModal] = useState(null);
  const [batchError, setBatchError] = useState('');
  const [openMenuId, setOpenMenuId] = useState(null);

  useEffect(() => {
    if (!openMenuId) return;
    const handler = () => setOpenMenuId(null);
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [openMenuId]);

  const handleViewInvoice = (invoiceNumber) => {
    api
      .postCreate('/get-invoice-file', {}, { action: 'download', invoice_number: invoiceNumber })
      .then(res => window.open(res.get_url, '_blank'))
      .catch(err => console.log(err));
  };

  // ---------------------------------------------------------------------------
  // Filtered orders
  // ---------------------------------------------------------------------------
  const filtered = useMemo(() => {
    return orders.filter(o => {
      if (selectedFirmId && o.firm_id !== selectedFirmId) return false;
      // Date range
      if (dateFrom) {
        const created = o.created_at.split('T')[0];
        if (created < dateFrom) return false;
      }
      if (dateTo) {
        const created = o.created_at.split('T')[0];
        if (created > dateTo) return false;
      }

      // Status filter
      if (statusFilter === 'pending') {
        if (o.ar.status !== 'pending' && o.ap.status !== 'pending') return false;
      } else if (statusFilter === 'unpaid_ar') {
        if (!['pending', 'invoiced'].includes(o.ar.status)) return false;
      } else if (statusFilter === 'unpaid_ap') {
        if (o.ap.status !== 'pending') return false;
      } else if (statusFilter === 'settled') {
        if (o.ar.status !== 'paid' || o.ap.status !== 'paid') return false;
      }

      // Search
      if (searchText) {
        const q = searchText.toLowerCase();
        if (
          !o.title_company.toLowerCase().includes(q) &&
          !o.file_number.toLowerCase().includes(q) &&
          !o.notary_name.toLowerCase().includes(q) &&
          !o.appointment_name.toLowerCase().includes(q)
        ) return false;
      }

      return true;
    });
  }, [orders, dateFrom, dateTo, statusFilter, searchText, selectedFirmId]);

  // ---------------------------------------------------------------------------
  // Summary cards (computed from ALL orders, not just filtered)
  // ---------------------------------------------------------------------------
  const summary = useMemo(() => {
    const thisMonth = new Date().toISOString().slice(0, 7);
    return {
      outstandingAR: orders.filter(o => o.ar.status === 'invoiced').reduce((s, o) => s + o.ar.amount, 0),
      owedNotaries:  orders.filter(o => o.ap.status === 'pending').reduce((s, o) => s + o.ap.amount, 0),
      pendingSync:   orders.filter(o => o.ar.status === 'pending').length,
      voidedCount:   orders.filter(o => o.ar.voided_at?.startsWith(thisMonth) || o.ap.voided_at?.startsWith(thisMonth)).length,
      get netPosition() { return this.outstandingAR - this.owedNotaries; },
    };
  }, [orders]);

  // ---------------------------------------------------------------------------
  // Selection
  // ---------------------------------------------------------------------------
  const allFilteredIds = filtered.map(o => o.order_id);
  const allSelected = allFilteredIds.length > 0 && allFilteredIds.every(id => selectedIds.has(id));

  const toggleAll = () => {
    if (allSelected) {
      setSelectedIds(new Set());
    } else {
      setSelectedIds(new Set(allFilteredIds));
    }
    setBatchError('');
  };

  const toggleRow = (id) => {
    const next = new Set(selectedIds);
    next.has(id) ? next.delete(id) : next.add(id);
    setSelectedIds(next);
    setBatchError('');
  };

  const clearSelection = () => { setSelectedIds(new Set()); setBatchError(''); };

  // ---------------------------------------------------------------------------
  // State mutation helpers (update local state; API call would go here)
  // ---------------------------------------------------------------------------
  const updateOrder = (orderId, updater) => {
    setOrders(prev => prev.map(o => o.order_id === orderId ? updater(o) : o));
  };

  const handleSyncToQB = (orderId) => {
    // TODO: POST /api/financials/sync-to-qb { order_ids: [orderId] }
    updateOrder(orderId, o => ({
      ...o,
      ar: { ...o.ar, status: 'invoiced', qb_invoice_id: `QB-INV-${Math.floor(Math.random() * 9000 + 1000)}` }
    }));
  };

  const handleBatchSyncToQB = () => {
    const sel = filtered.filter(o => selectedIds.has(o.order_id));
    const invalid = sel.filter(o => o.ar.status !== 'pending');
    if (invalid.length > 0) {
      setBatchError('All selected orders must have AR status "pending" to batch sync.');
      return;
    }
    // TODO: POST /api/financials/sync-to-qb { order_ids: [...] }
    sel.forEach(o => handleSyncToQB(o.order_id));
    clearSelection();
  };

  const handleRecordARPayment = (orderIds, checkNumber, paymentDate) => {
    // TODO: POST /api/financials/payments/ar { order_ids, check_number, payment_date }
    orderIds.forEach(id => {
      updateOrder(id, o => ({
        ...o,
        ar: { ...o.ar, status: 'paid', qb_payment_id: `QB-PMT-${Math.floor(Math.random() * 900 + 100)}`, check_number: checkNumber, payment_date: paymentDate }
      }));
    });
    setActiveModal(null);
    clearSelection();
  };

  const handleRecordAPPayment = (orderIds, checkNumber, paymentDate) => {
    // TODO: POST /api/financials/payments/ap { order_ids, check_number, payment_date }
    orderIds.forEach(id => {
      updateOrder(id, o => ({
        ...o,
        ap: { ...o.ap, status: 'paid', qb_expense_id: `QB-EXP-${Math.floor(Math.random() * 900 + 100)}`, check_number: checkNumber, payment_date: paymentDate }
      }));
    });
    setActiveModal(null);
    clearSelection();
  };

  const handleVoid = (orderId, side, reason) => {
    // TODO: POST /api/financials/{orderId}/{side}/void { reason }
    updateOrder(orderId, o => ({
      ...o,
      [side]: { ...o[side], status: 'voided', voided_at: new Date().toISOString(), void_reason: reason }
    }));
    setActiveModal(null);
  };

  const handleEditFee = (orderId, side, amount, reason) => {
    // TODO: PUT /api/financials/{orderId}/{side}/amount { amount, reason }
    updateOrder(orderId, o => ({
      ...o,
      [side]: { ...o[side], amount }
    }));
    setActiveModal(null);
  };

  // ---------------------------------------------------------------------------
  // Batch action handlers
  // ---------------------------------------------------------------------------
  const openBatchARPayment = () => {
    const sel = filtered.filter(o => selectedIds.has(o.order_id));
    const firmIds = new Set(sel.map(o => o.firm_id));
    if (firmIds.size > 1) {
      setBatchError('Batch title company payment requires all selected orders to be from the same firm.');
      return;
    }
    const invalid = sel.filter(o => o.ar.status !== 'invoiced');
    if (invalid.length > 0) {
      setBatchError('All selected orders must have AR status "invoiced" to record a batch payment.');
      return;
    }
    setActiveModal({ type: 'payment_ar', orderIds: sel.map(o => o.order_id) });
    setBatchError('');
  };

  const openBatchAPPayment = () => {
    const sel = filtered.filter(o => selectedIds.has(o.order_id));
    const notaryIds = new Set(sel.map(o => o.notary_id));
    if (notaryIds.size > 1) {
      setBatchError('Batch notary payment requires all selected orders to be for the same notary.');
      return;
    }
    const invalid = sel.filter(o => o.ap.status !== 'pending');
    if (invalid.length > 0) {
      setBatchError('All selected orders must have AP status "pending" to record a batch notary payment.');
      return;
    }
    setActiveModal({ type: 'payment_ap', orderIds: sel.map(o => o.order_id) });
    setBatchError('');
  };

  const selectedCount = selectedIds.size;

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  return (
    <div className="space-y-5">
      {/* QB reconnect banner */}
      {!qbConnected && (
        <div className="bg-amber-50 border border-amber-300 text-amber-800 rounded-xl px-4 py-3 flex items-center gap-3 text-sm">
          <span>QuickBooks connection lost.</span>
          <button className="underline font-medium hover:text-amber-900">Reconnect QuickBooks</button>
        </div>
      )}

      {/* Page header */}
      <div>
        <h1 className="text-xl font-bold text-neutral-800">Financials</h1>
        <div className="w-12 h-1 bg-blue-500 rounded mt-1"></div>
      </div>

      {/* Summary cards */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        <SummaryCard label="Outstanding AR" value={fmt(summary.outstandingAR)} sub="invoiced, unpaid" />
        <SummaryCard label="Owed to Notaries" value={fmt(summary.owedNotaries)} sub="pending payment" />
        <SummaryCard label="Pending QB Sync" value={summary.pendingSync} sub="orders not yet in QB" />
        <SummaryCard
          label="Net Position"
          value={fmt(summary.netPosition)}
          sub={summary.netPosition >= 0 ? 'net receivable' : 'net payable'}
        />
        <SummaryCard label="Voided This Month" value={summary.voidedCount} sub="records" />
      </div>

      {/* Filters */}
      <div className="bg-white rounded-xl shadow-sm border border-neutral-200 px-4 sm:px-6 py-4">
        <div className="flex flex-wrap gap-4 items-end">
          <div>
            <label className="block text-xs font-medium text-neutral-500 mb-1 uppercase tracking-wide">From</label>
            <input
              type="date"
              value={dateFrom}
              onChange={e => setDateFrom(e.target.value)}
              className="px-3 py-2 border border-neutral-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-neutral-500 mb-1 uppercase tracking-wide">To</label>
            <input
              type="date"
              value={dateTo}
              onChange={e => setDateTo(e.target.value)}
              className="px-3 py-2 border border-neutral-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-neutral-500 mb-1 uppercase tracking-wide">Status</label>
            <select
              value={statusFilter}
              onChange={e => setStatusFilter(e.target.value)}
              className="px-3 py-2 border border-neutral-300 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            >
              <option value="all">All</option>
              <option value="pending">Pending</option>
              <option value="unpaid_ar">Unpaid AR</option>
              <option value="unpaid_ap">Unpaid AP</option>
              <option value="settled">Fully Settled</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-neutral-500 mb-1 uppercase tracking-wide">Title Company</label>
            <select
              value={selectedFirmId}
              onChange={e => setSelectedFirmId(e.target.value)}
              className="px-3 py-2 border border-neutral-300 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            >
              <option value="">All firms</option>
              {firms.map(f => (
                <option key={f.org_id} value={f.org_id}>{f.org_name}</option>
              ))}
            </select>
          </div>
          <div className="flex-1 min-w-[180px]">
            <label className="block text-xs font-medium text-neutral-500 mb-1 uppercase tracking-wide">Search</label>
            <input
              type="text"
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              placeholder="Title company, file #, notary..."
              className="w-full px-3 py-2 border border-neutral-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            />
          </div>
          {searchText && (
            <button
              onClick={() => setSearchText('')}
              className="px-3 py-2 text-sm text-neutral-500 hover:text-neutral-700"
            >
              Clear
            </button>
          )}
        </div>
      </div>

      {/* Batch action bar */}
      {selectedCount > 0 && (
        <div className="bg-blue-50 border border-blue-200 rounded-xl px-4 py-3 flex flex-wrap items-center gap-3">
          <span className="text-sm font-medium text-blue-800">{selectedCount} selected</span>
          <button
            onClick={handleBatchSyncToQB}
            className="px-3 py-1.5 text-xs font-medium bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
          >
            Batch Sync to QB
          </button>
          <button
            onClick={openBatchARPayment}
            className="px-3 py-1.5 text-xs font-medium bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
          >
            Batch Title Co Payment
          </button>
          <button
            onClick={openBatchAPPayment}
            className="px-3 py-1.5 text-xs font-medium bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
          >
            Batch Notary Payment
          </button>
          <button
            onClick={clearSelection}
            className="ml-auto px-3 py-1.5 text-xs font-medium text-neutral-600 hover:text-neutral-800 rounded-lg"
          >
            Clear selection
          </button>
          {batchError && (
            <p className="w-full text-xs text-red-600 mt-1">{batchError}</p>
          )}
        </div>
      )}

      {/* Table */}
      <div className="bg-white rounded-xl shadow-sm border border-neutral-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-neutral-50 border-b border-neutral-200">
                <th className="px-3 py-3 text-left">
                  <input
                    type="checkbox"
                    checked={allSelected}
                    onChange={toggleAll}
                    className="rounded border-neutral-300"
                  />
                </th>
                <th className="px-3 py-3 text-left text-xs font-semibold text-neutral-500 uppercase tracking-wide whitespace-nowrap">File #</th>
                <th className="px-3 py-3 text-left text-xs font-semibold text-neutral-500 uppercase tracking-wide whitespace-nowrap">Title Company</th>
                <th className="px-3 py-3 text-left text-xs font-semibold text-neutral-500 uppercase tracking-wide whitespace-nowrap">Appointment</th>
                <th className="px-3 py-3 text-left text-xs font-semibold text-neutral-500 uppercase tracking-wide whitespace-nowrap">Notary</th>
                <th className="px-3 py-3 text-left text-xs font-semibold text-neutral-500 uppercase tracking-wide whitespace-nowrap">Invoice #</th>
                <th className="px-3 py-3 text-right text-xs font-semibold text-neutral-500 uppercase tracking-wide whitespace-nowrap">Title Fee</th>
                <th className="px-3 py-3 text-center text-xs font-semibold text-neutral-500 uppercase tracking-wide">AR</th>
                <th className="px-3 py-3 text-right text-xs font-semibold text-neutral-500 uppercase tracking-wide whitespace-nowrap">Notary Fee</th>
                <th className="px-3 py-3 text-center text-xs font-semibold text-neutral-500 uppercase tracking-wide">AP</th>
                <th className="px-3 py-3 text-right text-xs font-semibold text-neutral-500 uppercase tracking-wide">Margin</th>
                <th className="px-3 py-3 text-left text-xs font-semibold text-neutral-500 uppercase tracking-wide">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-neutral-100">
              {filtered.length === 0 && (
                <tr>
                  <td colSpan={12} className="px-4 py-10 text-center text-sm text-neutral-400">
                    No records match the current filters.
                  </td>
                </tr>
              )}
              {filtered.map(o => {
                const isVoided = o.ar.status === 'voided' && o.ap.status === 'voided';
                const margin = isVoided ? null : o.ar.amount - o.ap.amount;

                return (
                  <tr
                    key={o.order_id}
                    className={`hover:bg-neutral-50 transition-colors ${isVoided ? 'opacity-50' : ''}`}
                  >
                    {/* Checkbox */}
                    <td className="px-3 py-3">
                      <input
                        type="checkbox"
                        checked={selectedIds.has(o.order_id)}
                        onChange={() => toggleRow(o.order_id)}
                        className="rounded border-neutral-300"
                      />
                    </td>

                    {/* File # */}
                    <td className="px-3 py-3 font-medium text-neutral-700 whitespace-nowrap">{o.file_number}</td>

                    {/* Title company */}
                    <td className="px-3 py-3 text-neutral-600 whitespace-nowrap">{o.title_company}</td>

                    {/* Appointment */}
                    <td className="px-3 py-3 text-neutral-600 whitespace-nowrap">{o.appointment_name}</td>

                    {/* Notary */}
                    <td className="px-3 py-3 text-neutral-600 whitespace-nowrap">{o.notary_name}</td>

                    {/* Invoice # */}
                    <td className="px-3 py-3 whitespace-nowrap">
                      <button
                        onClick={() => handleViewInvoice(o.pinpoint_invoice_number)}
                        className="text-blue-600 hover:text-blue-800 hover:underline text-sm font-medium"
                      >
                        {o.pinpoint_invoice_number}
                      </button>
                    </td>

                    {/* AR amount */}
                    <td className="px-3 py-3 text-right font-medium text-neutral-700 whitespace-nowrap">{fmt(o.ar.amount)}</td>

                    {/* AR status */}
                    <td className="px-3 py-3 text-center">{statusBadge(o.ar.status, o.ar.status === 'voided')}</td>

                    {/* AP amount */}
                    <td className="px-3 py-3 text-right font-medium text-neutral-700 whitespace-nowrap">{fmt(o.ap.amount)}</td>

                    {/* AP status */}
                    <td className="px-3 py-3 text-center">{statusBadge(o.ap.status, o.ap.status === 'voided')}</td>

                    {/* Margin */}
                    <td className="px-3 py-3 text-right whitespace-nowrap">
                      {margin === null ? (
                        <span className="text-neutral-400">—</span>
                      ) : (
                        <span className={margin >= 0 ? 'text-green-700 font-medium' : 'text-red-600 font-medium'}>
                          {fmt(margin)}
                        </span>
                      )}
                    </td>

                    {/* Actions */}
                    <td className="px-3 py-3">
                      <div className="flex items-center gap-1">
                        {/* Primary: Sync to QB */}
                        {o.ar.status === 'pending' && (
                          <button
                            onClick={() => handleSyncToQB(o.order_id)}
                            className="px-2 py-1 text-xs font-medium bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors whitespace-nowrap"
                          >
                            Sync to QB
                          </button>
                        )}

                        {/* Primary: Pay Notary */}
                        {o.ap.status === 'pending' && (
                          <button
                            onClick={() => setActiveModal({ type: 'payment_ap', orderIds: [o.order_id] })}
                            className="px-2 py-1 text-xs font-medium bg-indigo-600 hover:bg-indigo-700 text-white rounded transition-colors whitespace-nowrap"
                          >
                            Pay Notary
                          </button>
                        )}

                        {/* More menu */}
                        {(o.ar.status === 'invoiced' ||
                          !['paid','voided'].includes(o.ar.status) ||
                          !['paid','voided'].includes(o.ap.status) ||
                          o.ar.status !== 'voided' ||
                          o.ap.status !== 'voided') && (
                          <div className="relative">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setOpenMenuId(openMenuId === o.order_id ? null : o.order_id);
                              }}
                              className="px-2 py-1 text-xs font-medium bg-neutral-100 hover:bg-neutral-200 text-neutral-600 rounded transition-colors"
                            >
                              More ···
                            </button>

                            {openMenuId === o.order_id && (
                              <div className="absolute right-0 z-20 mt-1 bg-white rounded-lg shadow-lg border border-neutral-200 py-1 min-w-[180px]">
                                {o.ar.status === 'invoiced' && (
                                  <button
                                    onClick={() => { setActiveModal({ type: 'payment_ar', orderIds: [o.order_id] }); setOpenMenuId(null); }}
                                    className="w-full text-left px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50"
                                  >
                                    Record Title Co Payment
                                  </button>
                                )}
                                {!['paid','voided'].includes(o.ar.status) && (
                                  <button
                                    onClick={() => { setActiveModal({ type: 'edit_fee', orderId: o.order_id, side: 'ar', currentAmount: o.ar.amount }); setOpenMenuId(null); }}
                                    className="w-full text-left px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50"
                                  >
                                    Edit Title Co Fee
                                  </button>
                                )}
                                {!['paid','voided'].includes(o.ap.status) && (
                                  <button
                                    onClick={() => { setActiveModal({ type: 'edit_fee', orderId: o.order_id, side: 'ap', currentAmount: o.ap.amount }); setOpenMenuId(null); }}
                                    className="w-full text-left px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50"
                                  >
                                    Edit Notary Fee
                                  </button>
                                )}
                                {(o.ar.status !== 'voided' || o.ap.status !== 'voided') && (
                                  <div className="border-t border-neutral-100 my-1" />
                                )}
                                {o.ar.status !== 'voided' && (
                                  <button
                                    onClick={() => { setActiveModal({ type: 'void', orderId: o.order_id, side: 'ar' }); setOpenMenuId(null); }}
                                    className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                                  >
                                    Void AR
                                  </button>
                                )}
                                {o.ap.status !== 'voided' && (
                                  <button
                                    onClick={() => { setActiveModal({ type: 'void', orderId: o.order_id, side: 'ap' }); setOpenMenuId(null); }}
                                    className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                                  >
                                    Void AP
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {filtered.length > 0 && (
          <div className="px-4 py-3 border-t border-neutral-100 text-xs text-neutral-400">
            Showing {filtered.length} of {orders.length} orders
          </div>
        )}
      </div>

      {/* Modals */}
      {activeModal?.type === 'payment_ar' && (
        <AdminFinancialsPaymentModal
          type="ar"
          orderIds={activeModal.orderIds}
          orders={orders}
          onConfirm={(checkNumber, paymentDate) => handleRecordARPayment(activeModal.orderIds, checkNumber, paymentDate)}
          onClose={() => setActiveModal(null)}
        />
      )}

      {activeModal?.type === 'payment_ap' && (
        <AdminFinancialsPaymentModal
          type="ap"
          orderIds={activeModal.orderIds}
          orders={orders}
          onConfirm={(checkNumber, paymentDate) => handleRecordAPPayment(activeModal.orderIds, checkNumber, paymentDate)}
          onClose={() => setActiveModal(null)}
        />
      )}

      {activeModal?.type === 'void' && (
        <AdminFinancialsVoidModal
          orderId={activeModal.orderId}
          side={activeModal.side}
          onConfirm={(reason) => handleVoid(activeModal.orderId, activeModal.side, reason)}
          onClose={() => setActiveModal(null)}
        />
      )}

      {activeModal?.type === 'edit_fee' && (
        <AdminFinancialsEditFeeModal
          orderId={activeModal.orderId}
          side={activeModal.side}
          currentAmount={activeModal.currentAmount}
          onConfirm={(amount, reason) => handleEditFee(activeModal.orderId, activeModal.side, amount, reason)}
          onClose={() => setActiveModal(null)}
        />
      )}
    </div>
  );
};

export default AdminFinancials;
